<!--  -->
<template>
  <div class='index-page'>
    <div class="head">
      <img :src="require('../../assets/image_1/410.png')" alt="" style="width: 100%;" />
    </div>
    <!-- <div id="swipercom">
    <div class="swiper-container" id="swiperIndex">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, i) in imgs" :key="i" @click="imgClick(item.url)">
          <img :src="item.pic" alt="" />
        </div>
      </div>

      <div class="swiper-pagination"></div>

      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
  </div> -->
    <swiper-bottom></swiper-bottom>
    <part-two></part-two>
    <part-three></part-three>
    <part-four @openDialog="openDialog"></part-four>
    <part-five @openDialog="openDialog"></part-five>
    <!-- <part-six></part-six> -->
    <!-- <part-seven></part-seven> -->
    <part-eight @openDialog="openDialog"></part-eight>
    <part-nine></part-nine>
    <!-- <index-dialog v-model:show="dialogVisible"></index-dialog> -->
  </div>
</template>

<script>
import index_controller from "./index_controller";
export default index_controller;
</script>
<style scoped>
.head {
  position: relative;
}

.head-title {
  position: absolute;
  top: 130px;
  left: 50%;
  font-weight: bold;
  font-size: 40px;
  color: #FFFFFF;
  line-height: 1;
  transform: translateX(-50%);
  text-align: center;
  z-index: 10;
}

.head-title-bottom {
  font-weight: 400;
  font-size: 24px;
  margin-top: 33px;
}

/* @import url(); 引入公共css类 */
#swipercom {
  width: 100%;
}

#swipercom img {
  width: 100%;
}

::v-deep .swiper-pagination-bullet {
  width: 46px !important;
  border-radius: 0 !important;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal>.swiper-pagination-bullets {
  bottom: 50px;
}

::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-dialog__footer {
  padding: 0;
}

::v-deep .el-dialog--center .el-dialog__body {
  padding: 0;
}

::v-deep .el-dialog--center {
  border-radius: 10px;
}
</style>